/* wg-al-flags.js - Wade Greens
   Tags the "PROUDLY GROWN IN ALABAMA" announcement slide with .wg-al-flag so
   assets/wg-al-flags.css can hang the USA and Alabama flags off it.

   WHY A SCRIPT AT ALL. The announcement bar rotates three different messages
   and CSS has no text-content selector, so there is no way to reach one slide
   from the stylesheet alone. The section that renders the bar takes its text
   from theme settings, so a Liquid-side class is not available either.

   WHY IT RE-RUNS. slick clones the first and last slides for the infinite
   loop and rebuilds the track on resize, which drops any class added earlier.
   The MutationObserver re-tags whatever appears. It is cheap - the callback
   only touches .announcement-bar__message nodes and bails if the class is
   already on.

   MATCHING is on the uppercase string ALABAMA, which is specific enough here:
   the other two messages are about fall planting and free shipping. If a new
   announcement is written that happens to mention Alabama it will also get
   flags, which is the intended behaviour rather than a bug.
*/
(function () {
  var SEL = '.announcement-bar__message';

  function tag() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var isAL = (n.textContent || '').toUpperCase().indexOf('ALABAMA') !== -1;
      if (isAL && !n.classList.contains('wg-al-flag')) {
        n.classList.add('wg-al-flag');
      } else if (!isAL && n.classList.contains('wg-al-flag')) {
        n.classList.remove('wg-al-flag');
      }
    }
  }

  function start() {
    tag();
    var bar = document.querySelector('.announcement-bar');
    if (!bar || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tag(); });
    }).observe(bar, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
